import { useSpring, animated } from "react-spring-new";
import { faTint } from "@fortawesome/pro-solid-svg-icons";
import { DataFormat } from "imports/Utils";
import { Tooltip } from "@mui/material";
import { intl } from "LocaleWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const UsageIndicator = ({ report: { estimatedFuelConsumption, actualFuelConsumption, gasOilPrice, minPrice, maxPrice } }) => {

	const circlePath = `M18 2.0845
		a 15.9155 15.9155 0 0 1 0 31.831
		a 15.9155 15.9155 0 0 1 0 -31.831`;
	const expectedLength = 60;
	const lengthFactor = actualFuelConsumption ? estimatedFuelConsumption ? actualFuelConsumption / estimatedFuelConsumption : 1 : 0;

	const current = useSpring({
		from: { stroke: "7, 100", number: 0 },
		to: { stroke: lengthFactor ? `${Math.min(expectedLength * lengthFactor, 100)}, 100` : "7, 100", number: actualFuelConsumption },
		delay: 800,
	});

	const expected = useSpring({
		from: { stroke: "5, 100", number: 0 },
		to: { stroke: estimatedFuelConsumption ? "60, 100" : "5, 100", number: estimatedFuelConsumption },
		delay: 300,
	});

	const buildPrice = () => {
		if (gasOilPrice) {
			if (minPrice && maxPrice && (minPrice != gasOilPrice || maxPrice != gasOilPrice)) {
				return <Tooltip title={`${DataFormat.price(minPrice)} - ${DataFormat.price(maxPrice)}`} placement="top">
					<span className="estimate-price">{DataFormat.price(gasOilPrice)}</span>
				</Tooltip>;
			}
			return <span>{DataFormat.price(gasOilPrice)}</span>;
		}
		return <span>€0</span>;
	};

	return <div className="wheel-container">
		<svg viewBox="0 0 36 36" className="wheel" width="100">
			<animated.path id="circ"
				className="circle"
				d={circlePath}
				strokeDasharray={current.stroke}
				stroke="black" />
		</svg>
		<div className="log-block-usage-text-container">
			<animated.span className="log-block-current-usage">{actualFuelConsumption ? current.number.to(n => n.toFixed(0) + "L") : intl.formatMessage({ id: "UNKNOWN" })}</animated.span>
		</div>
		<svg viewBox="0 0 36 36" className="wheel wheel2" width="100">
			<animated.path id="circ2"
				className="circle"
				d={circlePath}
				strokeDasharray={expected.stroke}
				stroke="black"  />
		</svg>
		 <div className="log-block-usage-text-container">
			<animated.span className="log-block-expected-usage">{estimatedFuelConsumption ? expected.number.to(n => n.toFixed(0) + "L") : intl.formatMessage({ id: "UNKNOWN" })}</animated.span>
		</div>
		<div className="log-block-usage-gasoil-price">
			<FontAwesomeIcon icon={faTint} />
			{buildPrice()}
		</div>
	</div>;
};

export default UsageIndicator;
